import Personage from '@/view/Cust/Personage'
import connectCust from '@/view/Cust/Personage/connectCust'
import Enterprise from '@/view/Cust/Enterprise'
import connectEnterprise from '@/view/Cust/Enterprise/connectEnterprise'
import addCust from '@/view/Cust/Personage/addPersonCust'
import addEnterprise from '@/view/Cust/Enterprise/addEnterprise'
import acctregPage from '@/view/Cust/acctreg/index.vue'
import acctregDetail from '@/view/Cust/acctreg/detail.vue'
import personReg from '@/view/Cust/acctreg/personReg.vue'
import religionReg from '@/view/Cust/acctreg/religionReg.vue'

export default [
    {path: '/cust/personage', name: 'Personage', component: Personage, meta: '个人客户管理'},
    {path: '/cust/personage/connectCust', component: connectCust, meta: '关联个人客户'},
    {path: '/cust/enterprise', name: 'Enterprise', component: Enterprise, meta: '企业客户管理'},
    {path: '/cust/enterprise/connectEnterprise', component: connectEnterprise, meta: '企业客户关联'},
    {path: '/cust/personage/addCust', name: 'addCust', component: addCust, meta: '新增个人客户',},
    {path: '/cust/enterprise/addEnterprise', name: 'addEnterprise', component: addEnterprise, meta: '企业客户新增',},
    {path: '/cust/acctregPage', name: 'acctregPage', component: acctregPage, meta: '开户登记',},
    {path: '/cust/acctregDetail', name: 'acctregDetail', component: acctregDetail, meta: '开户登记详情',},
    {path: '/cust/personReg', name: 'personReg', component: personReg, meta: '开户登记',},
    {path: '/cust/religionReg', name: 'religionReg', component: religionReg, meta: '开户登记',},

]
